<template>
  <AutoSuggest
    v-model="valueModel"
    class="mb-4 status-filter"
    :label="label"
    multiple
    only-unique
    :source="localizedTournamentsStatusesAsArray"
    name="statusSelection"
    :placeholder="allPlaceholder"
    display-property="name"
    :show-on-focus="true"
  />
</template>

<script>
import { tournamentStatuses } from '@/mixins/tournaments/tournamentStatuses';
import AutoSuggest from '@/components/molecules/form/autoComplete/HeraAutosuggest.vue';

export default {
  name: 'Status',
  components: {
    AutoSuggest,
  },

  mixins: [tournamentStatuses(false, true)],
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Array, String],
      default: '',
    },
    allPlaceholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue.map(status => status.id));
      },
    },
  },

  created() {
    if (this.$route.params.closed) {
      this.$emit('input', ['closed']);
    }
  },
};
</script>
<style lang="scss"></style>
